import {connect} from 'react-redux';
import {Spectrophotometer as Component} from './Spectrophotometer';
import {
  createSpectrophotometer
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("spectrophotometers") &&
     state.notebook.protocolSection.scene.apparatus.spectrophotometers.some(
       spectrophotometer => spectrophotometer.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.spectrophotometers[ownProps.id-1].type,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createSpectrophotometer: (data)=>{
      dispatch(createSpectrophotometer(data))
    },
  };
}

export const Spectrophotometer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
